import React, { useEffect } from "react";
import { Header } from "../components/Common/Header";
import { QuizCard } from "../components/Quiz/QuizCard";

import BgImage from "../assets/images/Headers/Question.jfif";

export const Quiz = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header
        image={BgImage}
        title="Quiz"
      />

      <QuizCard
        btntext="Take Quiz"
        title="Is Coaching Your Path to Freedom & Success?"
        caption="Discover if Coaching is the Key to Unlocking Your Dream Career &
                Life! Take this quick quiz to find out if becoming an
                ICF-certified coach is the transformative change you need."
        image="/assets/images/Quiz/Quiz-1.avif"
        link="quiz1"
      />

      <QuizCard
        btntext="Take Quiz"
        title="Do you wish you could work and have time for Family?"
        caption="Looking for a way to earn, work flexibly, and still have time
                for your family and personal life? Take this quick quiz to find
                out if becoming an ICF-certified coach is the low-pressure
                career you’ve been searching for"
        image="/assets/images/Quiz/Quiz-2.jpg"
        invert={true}
        link="quiz2"
      />

      <QuizCard
        btntext="Take Quiz"
        title="Is Coaching the Career You’ve Been Searching For?"
        caption="Are you ready to explore a fulfilling, flexible career that lets you make an impact and achieve your personal and professional goals? Take this quiz to discover if coaching is the right path for you!"
        image="/assets/images/Quiz/Quiz-3.jpg"
        link="quiz3"
      />

      <QuizCard
        btntext="Take Quiz"
        title="Are You Ready to Turn Your Parenting Skills into a Flexible Career with Coaching?"
        caption="As an urban parent, you’re balancing a million things every day. But what if you could transform your passion for helping others into a fulfilling career that works around your family’s needs? Take this quiz to find out if coaching is the perfect fit for you!"
        image="/assets/images/Quiz/Quiz-4.webp"
        invert={true}
        link="quiz4"
      />

      <QuizCard
        btntext="Take Quiz"
        title="Take Your Coaching Career to the Next Level"
        caption="Challenge your coaching expertise with this quiz and discover how you can take your career to new heights!"
        image="/assets/images/Quiz/Quiz-5.jpg"
        link="quiz5"
      />
    </>
  );
};